import { useQuery, UseQueryResult } from '@taxdown/zeno-sama-query';
import ReferralService from 'Services/referral';
import { Profits, QueryKeys, ReferralLinksType, ResponseType } from 'Types/common';

const getRerrefalData = (response: ResponseType<ReferralLinksType>): ReferralLinksType => {
  const responseData = response.data;
  return responseData.item;
};

export const useFetchGetReferralLinks = (): UseQueryResult<ReferralLinksType> =>
  useQuery([QueryKeys.GET_LINKS], ReferralService.getLinks, {
    select: data => getRerrefalData(data),
    refetchOnWindowFocus: false,
    cacheTime: 0,
  });

export const useFetchGetProfitsReferral = (): UseQueryResult<Profits> =>
  useQuery([QueryKeys.GET_PROFITS], ReferralService.getProfits, {
    refetchOnWindowFocus: false,
    cacheTime: 0,
  });
